import React from 'react'
import { Text, csx, cx, TextProps } from '@vtex/admin-ui'

export type ProductNameProps = TextProps

export const ProductName = ({
  children,
  className = '',
  ...props
}: ProductNameProps) => (
  <Text
    variant="action1"
    className={cx(
      csx({
        display: '-webkit-box',
        height: '2rem',
        WebkitLineClamp: '2',
        WebkitBoxOrient: 'vertical',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        marginTop: '$space-3',
        '@tablet': {
          marginTop: '$space-4',
          text: '$title1',
        },
      }),
      className
    )}
    {...props}
  >
    {children}
  </Text>
)
